import React from 'react';

import bgLoginPng from '@assets/img/arts/bg-login.png';
import d2dNewSvg from '@assets/img/icons/d2d-new.svg';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import { url } from '@utils/pages';
import clsx from 'clsx';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const strings = createStrings({
  ja: {
    title: 'D2D MEMBERSシステムメンテナンス',
    contentTitle: '【お詫びとお知らせ】',
    contentSubtitle: 'ただいまシステムメンテナンス中です',
    contentBody: () => (
      <>
        平素よりD2Dをご利用いただき、誠にありがとうございます。 <br />
        誠に申し訳ございませんが、現在システムメンテナンスのため <br />
        <b>D2D MEMBERSシステム</b>
        のご利用を停止させていただいております。 <br />
        お客様には大変ご不便・ご迷惑をお掛け致しますが、
        <br />
        今しばらくお待ちいただけますようお願い申し上げます。
      </>
    ),
    toTop: 'TOPへ',
    copyright: '(C) Copyright 2022 FC STANDARD LOGISTICS. All rights reserved.',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    height: '100vh',
    background: `url("${bgLoginPng}")`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  },
  inner: {
    padding: '6rem',
    maxWidth: 1200,
    margin: '0 auto',
    [theme.breakpoints.down('xs')]: {
      padding: '1rem',
    },
  },
  content: {
    ...common.flexColumn,
    background: 'white',
    boxShadow: '0px 4px 4px rgb(0 0 0 / 25%)',
    padding: '1rem 2rem',
    textAlign: 'center',
    '& b': {
      ...common.textPrimary,
    },
  },
  d2dLogo: {
    height: 45,
    marginBottom: '3rem',
    marginTop: '3rem',
    [theme.breakpoints.down('xs')]: {
      marginBottom: '1rem',
    },
  },
  contentTitle: {
    ...common.textPrimary,
    [theme.breakpoints.down('xs')]: {
      ...common.normalText,
      ...common.fontWeight600,
    },
  },
  contentSubtitle: {
    [theme.breakpoints.down('xs')]: {
      ...common.middleText,
      ...common.fontWeight600,
    },
  },
  contentBody: {
    [theme.breakpoints.down('xs')]: {
      ...common.middleText,
      textAlign: 'left',
      '& br': {
        display: 'none',
      },
    },
  },
}));

export const Maintenance: React.FC = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <div className={classes.container}>
      <Helmet>
        <title>{strings.title}</title>
      </Helmet>

      <div className={classes.inner}>
        <div className={classes.content}>
          <img src={d2dNewSvg} className={classes.d2dLogo} alt="D2D" />

          <h1 className={classes.contentTitle}>{strings.contentTitle}</h1>

          <h2 className={classes.contentSubtitle}>{strings.contentSubtitle}</h2>

          <p className={classes.contentBody}>{strings.contentBody()}</p>

          <a
            style={{ marginTop: '3rem' }}
            className={classes.textPrimary}
            href="https://d2dasia.com"
          >
            {strings.toTop}
          </a>

          <p
            style={{ marginTop: '4rem' }}
            className={clsx(classes.smallerText, classes.textGray700)}
          >
            {strings.copyright}

            <Link to={url('/dev/About')} style={{ float: 'right', opacity: 0.25 }}>
              Developers
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};
